import TransferDetail from "./styles";

export default TransferDetail;
